import { combineReducers } from "redux";
import appSettingsReducer from "./appSettingsReducer";
import loggedinReducer from "./loggedinReducer";

export default combineReducers({
  appSettingsReducer: appSettingsReducer,
  loggedinReducer: loggedinReducer
});
